var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { fill: "#90CDF4" }, attrs: { id: "app" } },
    [_c("demo", { attrs: { src: "home-page", start: 0, end: 2500 } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }